import { Component } from '@angular/core';
import { GridThemeEventsService } from 'src/@vex/services/grid.theme.service';
import { GRID_THEME_CONFIG } from 'src/app/helpers/ag-grid/grid-themes.config';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'toolbar-grid-theme',
  imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, FormsModule],
  templateUrl: './toolbar-grid-theme.component.html',
  styleUrl: './toolbar-grid-theme.component.scss',
})
export class ToolbarGridThemeComponent {
  selectedTheme: string = 'quartz';
  themes = GRID_THEME_CONFIG;

  constructor(private gridThemeEvents: GridThemeEventsService) {}

  ngOnInit() {
    this.selectedTheme = this.gridThemeEvents.getCurrentTheme().key;
  }


  setBaseTheme(event: any) {
    const themeId = event.value;
    const themeConfig = this.themes[themeId];

    this.selectedTheme = themeId; // 🔴 important
    this.gridThemeEvents.emitThemeConfig( themeId, themeConfig);
  }
}
